import styled from 'styled-components';

export const TestChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  max-width: calc(50% - 12px);
  height: 100%;
  padding-left: 24px;
`;

export const TestChatWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
`;

